export const formatPercent = (value) => {
  if (value == null) return '-';
  return `${Number(value).toFixed(2).replace(/\.00$/, '')}%`;
};

const toIsoDate = (date) => date.toISOString().slice(0, 10);

export const getDefaultDateRange = () => {
  const now = new Date();
  const start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  return {
    startDate: toIsoDate(start),
    endDate: toIsoDate(now)
  };
};

export const COUNTRY_OPTIONS = [
  { code: 'FRA', label: 'countries.france' },
  { code: 'DEU', label: 'countries.germany' },
  { code: 'JPN', label: 'countries.japan' },
  { code: 'MKD', label: 'countries.northMacedonia' },
  { code: 'POL', label: 'countries.poland' },
  { code: 'ZAF', label: 'countries.southAfrica' },
  { code: 'SWE', label: 'countries.sweden' },
  { code: 'GBR', label: 'countries.unitedKingdom' },
  { code: 'USA', label: 'countries.unitedStates' }
];